exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---2dVte {\n  min-height: 500px;\n  font-size: 14px;\n  min-width: 1324px;\n  height: 100%; }\n  .component---2dVte .header---7UucM {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding-bottom: 16px; }\n  .component---2dVte .header---7UucM h2 {\n      color: #415667;\n      font-size: 25px;\n      max-width: calc(100% - 16px);\n      font-weight: 500;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n  .component---2dVte .header---7UucM .date-range---1c5ZR {\n      display: block;\n      float: left;\n      clear: both;\n      font-size: 16px;\n      color: #1981c4; }\n  .component---2dVte .report-container---2IuYG {\n    border-top: 1px solid #e1e1e1;\n    margin-bottom: 16px; }\n  .component---2dVte .sub-header---_W_qN {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2dVte",
	"header": "header---7UucM",
	"date-range": "date-range---1c5ZR",
	"report-container": "report-container---2IuYG",
	"sub-header": "sub-header---_W_qN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/skill-quests-mastery/student/student.scss
// module id = JbS1
// module chunks = 1